import {
  initialState,
  Actions,
  State,
  GET_POST_INCREMENT,
  GET_POST_INCREMENT_SUCCESS,
  GET_POST_INCREMENT_ERROR,
  RESET_POST_INCREMENT,
} from "../../types/post-views/get-increment";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_POST_INCREMENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_POST_INCREMENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_POST_INCREMENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case RESET_POST_INCREMENT:
      return initialState;
    default:
      return state;
  }
};

export default reducers;

